import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { EUBanner } from "@/components/EUBanner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { Landing } from "@/components/Landing";
import { LegalPage } from "@/components/LegalPage";
import { PRIVACY, COOKIES, TERMS } from "@/data/legalContent";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 80);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    document.title = "AN CONTAB AUDIT — Contabilitate modernă pentru afaceri | Lighting in Accounting";
  }, []);

  return (
    <div className="App min-h-screen bg-white antialiased">
      <BrowserRouter>
        <EUBanner />
        <Header />
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/termeni-si-conditii" element={<LegalPage content={TERMS} />} />
          <Route path="/politica-de-confidentialitate" element={<LegalPage content={PRIVACY} />} />
          <Route path="/politica-de-cookies" element={<LegalPage content={COOKIES} />} />
          <Route path="*" element={<Landing />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
